import { Box, Stack } from "@mui/material";
import { ReactElement } from "react";
import { Outlet } from "react-router";
import { Match, MatchType } from "@cdv/jazz-ui";

export default function View(): ReactElement {
  return (
    <>
      <Box sx={{ mx: "auto", position: "relative" }}>
        <Stack sx={{ pb: 9, px: 2, mx: "auto" }} spacing={2}>
          <Match type={MatchType.Content} />
        </Stack>
      </Box>
    </>
  );
}
